import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const AdminMenu = ({ onTrigger }) => {
    const { pathname } = useLocation();
    const isApplicationsSection =
        pathname === "/acp" ||
        pathname === "/acp/" ||
        pathname.startsWith("/acp/check-characters");

    const isNewsSection = pathname.startsWith("/acp/news");
    const isLogsSection = pathname.startsWith("/acp/logs");

    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    const openSideMenu = () => {
        setMounted(true);
        requestAnimationFrame(() => setOpen(true));
    };

    const closeSideMenu = () => setOpen(false);

    useEffect(() => {
        if (onTrigger) onTrigger(openSideMenu);
    }, [onTrigger]);

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    useEffect(() => {
        if (!open && mounted) {
            const t = setTimeout(() => setMounted(false), 360);
            return () => clearTimeout(t);
        }
    }, [open, mounted]);

    if (!mounted) return null;

    return (
        <div
            className={`side-menu-overlay ${open ? "open" : ""}`}
            role="dialog"
            aria-hidden={!open}
            onClick={closeSideMenu}
        >
            <aside
                className="side-menu side-menu--admin"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="side-menu-button-close"
                    onClick={closeSideMenu}
                    aria-label="Закрыть"
                ></button>
                <div className="side-menu-list">
                    <Link
                        to="/acp/check-characters"
                        className={`side-menu-text ${isApplicationsSection ? "side-menu-text--active" : ""}`}
                        onClick={closeSideMenu}
                    >
                        ПРОВЕРКА ЗАЯВОК
                    </Link>
                    <span className="side-menu-text side-menu-text--muted">
                        АДМИНИСТРАТОРЫ
                    </span>
                    <span className="side-menu-text side-menu-text--muted">
                        ВЫДАЧА
                    </span>
                    <span className="side-menu-text side-menu-text--muted">
                        БЛОКИРОВКИ
                    </span>
                    <Link
                        to="/acp/news"
                        className={`side-menu-text ${isNewsSection ? "side-menu-text--active" : ""}`}
                        onClick={closeSideMenu}
                    >
                        НОВОСТИ
                    </Link>
                    <Link
                        to="/acp/logs"
                        className={`side-menu-text ${isLogsSection ? "side-menu-text--active" : ""}`}
                        onClick={closeSideMenu}
                    >
                        ЛОГИ
                    </Link>
                    <Link
                        to="/ucp"
                        className="side-menu-text"
                        onClick={closeSideMenu}
                    >
                        ВЫХОД
                    </Link>
                </div>
            </aside>
        </div>
    );
};

export default AdminMenu;
export { AdminMenu };
